import React, {Fragment} from 'react'
import { graphql, StaticQuery, Link } from 'gatsby'
import Media from 'react-media';




class Content extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
        
        const {bitmap_copy, mini, logo, header_mobile, group11, tcs_lilla} = this.props.query;
        return(
            <Fragment>
                <div className="two-section">
                    <div className="custom-container">
                        <h3>Visste du att?</h3>
                        <div className="col-md-6 col-sm-6 col-xs-12">
                            <div className="left-sporing for-desktop">
                                <p>Fysisk aktivitet kan förebygga en rad olika sjukdomar. <br/> Att röra på sig 60 minuter om dagen med måttlig till <br/> hög intensitet kan till exempel minska riskerna för <br/> diabetes typ 2 och hjärt- och kärlsjukdomar, men <br/> också minska risken för övervikt. Även små rörelser <br/> och lågintensiv aktivitet påverkar oss positivt. Så lite <br/> som en rörelsepaus på 2—3 minuter varje halvtimme <br/> kan göra skillnad.</p>	
                                <p>*Källa: Belcher BR et al. JCEM 2015;<br/> 
                                in press  <a href="#"> generationpep.se</a></p>
                            </div>
                            
                            <div className="left-sporing for-mobile">
                                <p>Fysisk aktivitet kan förebygga en rad olika <br/> sjukdomar. Att röra på sig 60 minuter om <br/> dagen med måttlig till hög intensitet kan <br/> till exempel minska riskerna för diabetes <br/> typ 2 och hjärt- och kärlsjukdomar, men <br/> också minska risken för övervikt. Även <br/> små rörelser och lågintensiv aktivitet <br/> påverkar oss positivt. Så lite som en <br/> rörelsepaus på 2—3 minuter varje <br/> halvtimme kan göra skillnad.</p>
                                <p>*Källa: Belcher BR et al. JCEM 2015;<br/> 
                                in press  <a href="#"> generationpep.se</a></p>
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-6 col-xs-12">
                            <div className="right-sporing for-desktop">
                                <p>När vi rör på oss frigörs så kallade signalsubstanser,  <br/> till exempel dopamin, serotonin och endorfiner. Dessa  <br/> signalsubstanser påverkar oss på olika sätt, och  <br/> hjälper oss att må bra. Dopamin och serotonin  <br/> motverkar till exempel depression och smärta, medan  <br/> endorfiner hjälper dig att känna dig gladare. Studier har även visat att fysisk aktivitet har positiv inverkan  <br/>  på självkänslan och sjävluppfattningen, vilket i sin tur  <br/>  påverkar vårt välbefinnande.</p>
                                <p>*Källa: Hur mycket fysisk aktivitet behöver barn <br/> 
                                och unga? / <a href="#">generationpep.se</a></p>
                            </div>
                            
                            <div className="right-sporing for-mobile">
                                <p>När vi rör på oss frigörs så kallade   <br/>  signalsubstanser, till exempel dopamin,   <br/>  serotonin och endorfiner. Dessa  <br/> signalsubstanser påverkar oss på olika   <br/>  sätt, och  hjälper oss att må bra. Dopamin  <br/> och serotonin  motverkar till exempel <br/>  depression och smärta, medan  endorfiner  <br/> hjälper dig att känna dig gladare. Studier  <br/> har även visat att fysisk aktivitet har <br/> positiv inverkan   på självkänslan och <br/> sjävluppfattningen, vilket i sin tur   påverkar  <br/> vårt välbefinnande.</p>
                                <p>*Källa: Hur mycket fysisk aktivitet behöver  <br/> barn 
                                och unga? / <a href="#">generationpep.se</a></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="logos-sporing">
                    <ul>
                        <li><img src={bitmap_copy.publicURL} /></li>
                        <li><img src={mini.publicURL}/></li>
                        <li><img src={logo.publicURL}/></li>
                        <li><img src={header_mobile.publicURL}/></li>
                        <li><img src={group11.publicURL}/></li>
                        <li><img src={tcs_lilla.publicURL}/></li>
                    </ul>
                </div>

                <section className="testa">
                    <h3>Barnens digitala mattelärare. <br/> <a href="javascript:void(0)"> Testa Albert gratis tillsvidare! </a></h3>
                    
                    <Media query="(max-width: 767px)">
                        {
                            matches =>
                                matches ? (
                                    <Link to="/register" onClick={ e => logEvent(
                                            `Junior Prova gratis i 30 dagar desktop button`,
                                            `Junior Prova gratis i 30 dagar desktop button was clicked`
                                        )                                    
                                    } className="prove">Prova gratis fram till skolstart</Link>
                                ) : (
                                    <Link to="/register"  onClick={ e => logEvent(
                                        `Junior Prova gratis i 30 dagar mobile button`,
                                        `Junior Prova gratis i 30 dagar mobile button was clicked`
                                    )                                    
                                }  className="prove">prova gratis<span className="line">Ordinarie pris 99 kr/mån</span></Link>
                                )
                        }
                    </Media>
                </section>
            </Fragment>
        )
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    bitmap_copy: file(relativePath: {regex: "/bitmap-copy/"}) {
                        publicURL
                    }
                    mini: file(relativePath: {regex: "/mini/"}) {
                        publicURL
                    }
                    logo: file(relativePath: {regex: "/logo-5/"}) {
                        publicURL
                    }
                    header_mobile: file(relativePath: {regex: "/header-mobile/"}) {
                        publicURL
                    }
                    group11: file(relativePath: {regex: "/group11/"}) {
                        publicURL
                    }
                    tcs_lilla: file(relativePath: {regex: "/tcs-lilla/"}) {
                        publicURL
                    }
                    
                }
                
                `
            }
        render={(data)  => (
           <Content query={data} {...props}/>
        )}
    />
)